/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountErrorCode {
  ACTIVATE_OWN_ACCOUNT = "ACTIVATE_OWN_ACCOUNT",
  ACTIVATE_SUPERUSER_ACCOUNT = "ACTIVATE_SUPERUSER_ACCOUNT",
  DEACTIVATE_OWN_ACCOUNT = "DEACTIVATE_OWN_ACCOUNT",
  DEACTIVATE_SUPERUSER_ACCOUNT = "DEACTIVATE_SUPERUSER_ACCOUNT",
  DELETE_NON_STAFF_USER = "DELETE_NON_STAFF_USER",
  DELETE_OWN_ACCOUNT = "DELETE_OWN_ACCOUNT",
  DELETE_STAFF_ACCOUNT = "DELETE_STAFF_ACCOUNT",
  DELETE_SUPERUSER_ACCOUNT = "DELETE_SUPERUSER_ACCOUNT",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
  INVALID_PASSWORD = "INVALID_PASSWORD",
  JWT_DECODE_ERROR = "JWT_DECODE_ERROR",
  JWT_INVALID_CSRF_TOKEN = "JWT_INVALID_CSRF_TOKEN",
  JWT_INVALID_TOKEN = "JWT_INVALID_TOKEN",
  JWT_MISSING_TOKEN = "JWT_MISSING_TOKEN",
  JWT_SIGNATURE_EXPIRED = "JWT_SIGNATURE_EXPIRED",
  LEFT_NOT_MANAGEABLE_PERMISSION = "LEFT_NOT_MANAGEABLE_PERMISSION",
  NOT_FOUND = "NOT_FOUND",
  OUT_OF_SCOPE_GROUP = "OUT_OF_SCOPE_GROUP",
  OUT_OF_SCOPE_PERMISSION = "OUT_OF_SCOPE_PERMISSION",
  OUT_OF_SCOPE_SERVICE_ACCOUNT = "OUT_OF_SCOPE_SERVICE_ACCOUNT",
  OUT_OF_SCOPE_USER = "OUT_OF_SCOPE_USER",
  PASSWORD_ENTIRELY_NUMERIC = "PASSWORD_ENTIRELY_NUMERIC",
  PASSWORD_TOO_COMMON = "PASSWORD_TOO_COMMON",
  PASSWORD_TOO_SHORT = "PASSWORD_TOO_SHORT",
  PASSWORD_TOO_SIMILAR = "PASSWORD_TOO_SIMILAR",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum AddressTypeEnum {
  BILLING = "BILLING",
  SHIPPING = "SHIPPING",
}

export enum AppErrorCode {
  FORBIDDEN = "FORBIDDEN",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  INVALID_MANIFEST_FORMAT = "INVALID_MANIFEST_FORMAT",
  INVALID_PERMISSION = "INVALID_PERMISSION",
  INVALID_STATUS = "INVALID_STATUS",
  INVALID_URL_FORMAT = "INVALID_URL_FORMAT",
  MANIFEST_URL_CANT_CONNECT = "MANIFEST_URL_CANT_CONNECT",
  NOT_FOUND = "NOT_FOUND",
  OUT_OF_SCOPE_APP = "OUT_OF_SCOPE_APP",
  OUT_OF_SCOPE_PERMISSION = "OUT_OF_SCOPE_PERMISSION",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum AppSortField {
  CREATION_DATE = "CREATION_DATE",
  NAME = "NAME",
}

export enum AppTypeEnum {
  LOCAL = "LOCAL",
  THIRDPARTY = "THIRDPARTY",
}

export enum AttributeInputTypeEnum {
  DROPDOWN = "DROPDOWN",
  MULTISELECT = "MULTISELECT",
}

export enum AttributeShowTypeEnum {
  COLORBALL = "COLORBALL",
  TEXTBOX = "TEXTBOX",
}

export enum AttributeSortField {
  AVAILABLE_IN_GRID = "AVAILABLE_IN_GRID",
  FILTERABLE_IN_DASHBOARD = "FILTERABLE_IN_DASHBOARD",
  FILTERABLE_IN_STOREFRONT = "FILTERABLE_IN_STOREFRONT",
  IS_VARIANT_ONLY = "IS_VARIANT_ONLY",
  NAME = "NAME",
  SLUG = "SLUG",
  STOREFRONT_SEARCH_POSITION = "STOREFRONT_SEARCH_POSITION",
  VALUE_REQUIRED = "VALUE_REQUIRED",
  VISIBLE_IN_STOREFRONT = "VISIBLE_IN_STOREFRONT",
}

export enum AttributeTypeEnum {
  PRODUCT = "PRODUCT",
  SKU = "SKU",
  VARIANT = "VARIANT",
}

export enum AttributeValueType {
  COLOR = "COLOR",
  GRADIENT = "GRADIENT",
  STRING = "STRING",
  URL = "URL",
}

export enum AuthorizationKeyType {
  FACEBOOK = "FACEBOOK",
  GOOGLE_OAUTH2 = "GOOGLE_OAUTH2",
  KAKAO = "KAKAO",
  NAVER = "NAVER",
}

export enum CategorySortField {
  NAME = "NAME",
  PRODUCT_COUNT = "PRODUCT_COUNT",
  SUBCATEGORY_COUNT = "SUBCATEGORY_COUNT",
}

export enum CollectionPublished {
  HIDDEN = "HIDDEN",
  PUBLISHED = "PUBLISHED",
}

export enum CollectionSortField {
  AVAILABILITY = "AVAILABILITY",
  DISPLAY_ORDER = "DISPLAY_ORDER",
  NAME = "NAME",
  PRODUCT_COUNT = "PRODUCT_COUNT",
  PUBLICATION_DATE = "PUBLICATION_DATE",
}

export enum CollectionUsedForEnum {
  COMPONENT_PAGE = "COMPONENT_PAGE",
  EMAIL_ATCR_SEVEN = "EMAIL_ATCR_SEVEN",
  EMAIL_ATCR_THREE = "EMAIL_ATCR_THREE",
  EMPTY_SHOPPING_BAG = "EMPTY_SHOPPING_BAG",
  GENERAL = "GENERAL",
  PRODUCT_PAGE = "PRODUCT_PAGE",
  PRODUCT_POPUP_MESSAGE = "PRODUCT_POPUP_MESSAGE",
  PRODUCT_RECOMMENDATION = "PRODUCT_RECOMMENDATION",
  SEARCH_PAGE = "SEARCH_PAGE",
}

export enum ComboSortField {
  ENABLE = "ENABLE",
  LAST_CHANGE = "LAST_CHANGE",
  NAME = "NAME",
  ORDER_NUMBER = "ORDER_NUMBER",
  TOTAL_PRICE = "TOTAL_PRICE",
}

export enum CommentParentTypeEnum {
  COMMENT = "COMMENT",
  INSTAGRAM = "INSTAGRAM",
  TIKTOK = "TIKTOK",
}

export enum CommentSourceTypeEnum {
  INSTAGRAM = "INSTAGRAM",
  SPACE = "SPACE",
  TIKTOK = "TIKTOK",
}

export enum ConfigurationTypeFieldEnum {
  BOOLEAN = "BOOLEAN",
  MULTILINE = "MULTILINE",
  OUTPUT = "OUTPUT",
  PASSWORD = "PASSWORD",
  SECRET = "SECRET",
  SECRETMULTILINE = "SECRETMULTILINE",
  STRING = "STRING",
}

export enum ContentPlatformEnum {
  INSTAGRAM = "INSTAGRAM",
  TIKTOK = "TIKTOK",
}

export enum ConversionMethodEnum {
  METHODFOUR = "METHODFOUR",
  METHODONE = "METHODONE",
  METHODTHREE = "METHODTHREE",
  METHODTWO = "METHODTWO",
}

export enum ConversionRateToCurrency {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BRL = "BRL",
  BSD = "BSD",
  BTC = "BTC",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHF = "CHF",
  CLF = "CLF",
  CLP = "CLP",
  CNH = "CNH",
  CNY = "CNY",
  COP = "COP",
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GGP = "GGP",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  IMP = "IMP",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JEP = "JEP",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRO = "MRO",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  SSP = "SSP",
  STD = "STD",
  STN = "STN",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  UYU = "UYU",
  UZS = "UZS",
  VEF = "VEF",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XAG = "XAG",
  XAU = "XAU",
  XCD = "XCD",
  XDR = "XDR",
  XOF = "XOF",
  XPD = "XPD",
  XPF = "XPF",
  XPT = "XPT",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZWL = "ZWL",
}

export enum CornerMarkErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum CornerMarkSortField {
  CREATED = "CREATED",
  ID = "ID",
  NAME = "NAME",
}

export enum CornerMarkTypeEnum {
  NORMAL = "NORMAL",
  PRE_ORDER = "PRE_ORDER",
  SOLD_OUT = "SOLD_OUT",
}

export enum CountryCode {
  AD = "AD",
  AE = "AE",
  AF = "AF",
  AG = "AG",
  AI = "AI",
  AL = "AL",
  AM = "AM",
  AO = "AO",
  AQ = "AQ",
  AR = "AR",
  AS = "AS",
  AT = "AT",
  AU = "AU",
  AW = "AW",
  AX = "AX",
  AZ = "AZ",
  BA = "BA",
  BB = "BB",
  BD = "BD",
  BE = "BE",
  BF = "BF",
  BG = "BG",
  BH = "BH",
  BI = "BI",
  BJ = "BJ",
  BL = "BL",
  BM = "BM",
  BN = "BN",
  BO = "BO",
  BQ = "BQ",
  BR = "BR",
  BS = "BS",
  BT = "BT",
  BV = "BV",
  BW = "BW",
  BY = "BY",
  BZ = "BZ",
  CA = "CA",
  CC = "CC",
  CD = "CD",
  CF = "CF",
  CG = "CG",
  CH = "CH",
  CI = "CI",
  CK = "CK",
  CL = "CL",
  CM = "CM",
  CN = "CN",
  CO = "CO",
  CR = "CR",
  CU = "CU",
  CV = "CV",
  CW = "CW",
  CX = "CX",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DJ = "DJ",
  DK = "DK",
  DM = "DM",
  DO = "DO",
  DZ = "DZ",
  EC = "EC",
  EE = "EE",
  EG = "EG",
  EH = "EH",
  ER = "ER",
  ES = "ES",
  ET = "ET",
  EU = "EU",
  FI = "FI",
  FJ = "FJ",
  FK = "FK",
  FM = "FM",
  FO = "FO",
  FR = "FR",
  GA = "GA",
  GB = "GB",
  GD = "GD",
  GE = "GE",
  GF = "GF",
  GG = "GG",
  GH = "GH",
  GI = "GI",
  GL = "GL",
  GM = "GM",
  GN = "GN",
  GP = "GP",
  GQ = "GQ",
  GR = "GR",
  GS = "GS",
  GT = "GT",
  GU = "GU",
  GW = "GW",
  GY = "GY",
  HK = "HK",
  HM = "HM",
  HN = "HN",
  HR = "HR",
  HT = "HT",
  HU = "HU",
  ID = "ID",
  IE = "IE",
  IL = "IL",
  IM = "IM",
  IN = "IN",
  IO = "IO",
  IQ = "IQ",
  IR = "IR",
  IS = "IS",
  IT = "IT",
  JE = "JE",
  JM = "JM",
  JO = "JO",
  JP = "JP",
  KE = "KE",
  KG = "KG",
  KH = "KH",
  KI = "KI",
  KM = "KM",
  KN = "KN",
  KP = "KP",
  KR = "KR",
  KW = "KW",
  KY = "KY",
  KZ = "KZ",
  LA = "LA",
  LB = "LB",
  LC = "LC",
  LI = "LI",
  LK = "LK",
  LR = "LR",
  LS = "LS",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  LY = "LY",
  MA = "MA",
  MC = "MC",
  MD = "MD",
  ME = "ME",
  MF = "MF",
  MG = "MG",
  MH = "MH",
  MK = "MK",
  ML = "ML",
  MM = "MM",
  MN = "MN",
  MO = "MO",
  MP = "MP",
  MQ = "MQ",
  MR = "MR",
  MS = "MS",
  MT = "MT",
  MU = "MU",
  MV = "MV",
  MW = "MW",
  MX = "MX",
  MY = "MY",
  MZ = "MZ",
  NA = "NA",
  NC = "NC",
  NE = "NE",
  NF = "NF",
  NG = "NG",
  NI = "NI",
  NL = "NL",
  NO = "NO",
  NP = "NP",
  NR = "NR",
  NU = "NU",
  NZ = "NZ",
  OM = "OM",
  PA = "PA",
  PE = "PE",
  PF = "PF",
  PG = "PG",
  PH = "PH",
  PK = "PK",
  PL = "PL",
  PM = "PM",
  PN = "PN",
  PR = "PR",
  PS = "PS",
  PT = "PT",
  PW = "PW",
  PY = "PY",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RS = "RS",
  RU = "RU",
  RW = "RW",
  SA = "SA",
  SB = "SB",
  SC = "SC",
  SD = "SD",
  SE = "SE",
  SG = "SG",
  SH = "SH",
  SI = "SI",
  SJ = "SJ",
  SK = "SK",
  SL = "SL",
  SM = "SM",
  SN = "SN",
  SO = "SO",
  SR = "SR",
  SS = "SS",
  ST = "ST",
  SV = "SV",
  SX = "SX",
  SY = "SY",
  SZ = "SZ",
  TC = "TC",
  TD = "TD",
  TF = "TF",
  TG = "TG",
  TH = "TH",
  TJ = "TJ",
  TK = "TK",
  TL = "TL",
  TM = "TM",
  TN = "TN",
  TO = "TO",
  TR = "TR",
  TT = "TT",
  TV = "TV",
  TW = "TW",
  TZ = "TZ",
  UA = "UA",
  UG = "UG",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VA = "VA",
  VC = "VC",
  VE = "VE",
  VG = "VG",
  VI = "VI",
  VN = "VN",
  VU = "VU",
  WF = "WF",
  WS = "WS",
  YE = "YE",
  YT = "YT",
  ZA = "ZA",
  ZM = "ZM",
  ZW = "ZW",
}

export enum CountryErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum CountrySortField {
  DISPLAY_ORDER = "DISPLAY_ORDER",
  ISO_NUMBER_CODE = "ISO_NUMBER_CODE",
  ISO_THREE_CODE = "ISO_THREE_CODE",
  ISO_TWO_CODE = "ISO_TWO_CODE",
  NAME = "NAME",
  REGIONS_COUNT = "REGIONS_COUNT",
}

export enum CoverCoverType {
  DETAILS = "DETAILS",
  FOUR_MAP_MASK = "FOUR_MAP_MASK",
}

export enum CoverSortField {
  CREATE_DATE = "CREATE_DATE",
  NAME = "NAME",
  SUBTITLE = "SUBTITLE",
  TITLE = "TITLE",
}

export enum CoverTypeEnum {
  DETAILS = "DETAILS",
  FOUR_MAP_MASK = "FOUR_MAP_MASK",
}

export enum CurrencyrateErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum CurrencyrateSortField {
  DISPLAY_ORDER = "DISPLAY_ORDER",
  IS_PUBLISHED = "IS_PUBLISHED",
  NAME = "NAME",
  ONLINE_RATE = "ONLINE_RATE",
  RATE = "RATE",
  SLUG = "SLUG",
  SYMBOL = "SYMBOL",
  UPDATE_DATE = "UPDATE_DATE",
}

export enum CustomPageStatus {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  INACTIVE = "INACTIVE",
  IN_REVIEW = "IN_REVIEW",
}

export enum DiscountErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum DiscountStatusEnum {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  SCHEDULED = "SCHEDULED",
}

export enum DiscountValueTypeEnum {
  CUSTOM = "CUSTOM",
  DIRECT = "DIRECT",
  FIXED = "FIXED",
  FREE = "FREE",
  PERCENTAGE = "PERCENTAGE",
}

export enum EmailSettingEmailType {
  TASK = "TASK",
  TRIGGER = "TRIGGER",
}

export enum ExportErrorCode {
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
}

export enum ExportScope {
  ALL = "ALL",
  FILTER = "FILTER",
  IDS = "IDS",
}

export enum ExportSubscriptionScope {
  ALL = "ALL",
  FILTER = "FILTER",
  IDS = "IDS",
}

export enum FileTypesEnum {
  CSV = "CSV",
  XLSX = "XLSX",
}

export enum FulfillmentStatus {
  CANCELED = "CANCELED",
  FULFILLED = "FULFILLED",
}

export enum HotSearchErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum InstagramCommentSortFidls {
  CREATED = "CREATED",
  NAME = "NAME",
}

export enum InstagramErrorCode {
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum InstagramLabelSortFidls {
  NAME = "NAME",
}

export enum InstagramSortFidls {
  CREATE_TIME = "CREATE_TIME",
  IMAGE = "IMAGE",
  INSTAGRAM_ID = "INSTAGRAM_ID",
  SHORTCODE = "SHORTCODE",
  TIME = "TIME",
  USERNAME = "USERNAME",
}

export enum InvoiceErrorCode {
  EMAIL_NOT_SET = "EMAIL_NOT_SET",
  INVALID_STATUS = "INVALID_STATUS",
  NOT_FOUND = "NOT_FOUND",
  NOT_READY = "NOT_READY",
  NUMBER_NOT_SET = "NUMBER_NOT_SET",
  REQUIRED = "REQUIRED",
  URL_NOT_SET = "URL_NOT_SET",
}

export enum JobStatusEnum {
  DELETED = "DELETED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

export enum LanguageCodeEnum {
  AR = "AR",
  AZ = "AZ",
  BG = "BG",
  BN = "BN",
  CA = "CA",
  CS = "CS",
  DA = "DA",
  DE = "DE",
  EL = "EL",
  EN = "EN",
  ES = "ES",
  ES_CO = "ES_CO",
  ET = "ET",
  FA = "FA",
  FI = "FI",
  FR = "FR",
  HI = "HI",
  HU = "HU",
  HY = "HY",
  ID = "ID",
  IS = "IS",
  IT = "IT",
  JA = "JA",
  KA = "KA",
  KM = "KM",
  KO = "KO",
  LT = "LT",
  MN = "MN",
  MY = "MY",
  NB = "NB",
  NL = "NL",
  PL = "PL",
  PT = "PT",
  PT_BR = "PT_BR",
  RO = "RO",
  RU = "RU",
  SK = "SK",
  SL = "SL",
  SQ = "SQ",
  SR = "SR",
  SV = "SV",
  SW = "SW",
  TA = "TA",
  TH = "TH",
  TR = "TR",
  UK = "UK",
  VI = "VI",
  ZH_HANS = "ZH_HANS",
  ZH_HANT = "ZH_HANT",
}

export enum LanguageCodeFilter {
  AR = "AR",
  AZ = "AZ",
  BG = "BG",
  BN = "BN",
  CA = "CA",
  CS = "CS",
  DA = "DA",
  DE = "DE",
  EL = "EL",
  EN = "EN",
  ES = "ES",
  ES_CO = "ES_CO",
  ET = "ET",
  FA = "FA",
  FI = "FI",
  FR = "FR",
  HI = "HI",
  HU = "HU",
  HY = "HY",
  ID = "ID",
  IS = "IS",
  IT = "IT",
  JA = "JA",
  KA = "KA",
  KM = "KM",
  KO = "KO",
  LT = "LT",
  MN = "MN",
  MY = "MY",
  NB = "NB",
  NL = "NL",
  PL = "PL",
  PT = "PT",
  PT_BR = "PT_BR",
  RO = "RO",
  RU = "RU",
  SK = "SK",
  SL = "SL",
  SQ = "SQ",
  SR = "SR",
  SV = "SV",
  SW = "SW",
  TA = "TA",
  TH = "TH",
  TR = "TR",
  UK = "UK",
  VI = "VI",
  ZH_HANS = "ZH_HANS",
  ZH_HANT = "ZH_HANT",
}

export enum LensTypeTemplateEnum {
  CLASSIC = "CLASSIC",
  PLUS = "PLUS",
}

export enum LoginPopupPopupType {
  NEW = "NEW",
  OLD = "OLD",
}

export enum LoginPopupPopupTypeEnum {
  NEW = "NEW",
  OLD = "OLD",
}

export enum MenuBannerTypeEnum {
  CAROUSEL = "CAROUSEL",
  IMAGE = "IMAGE",
}

export enum MenuErrorCode {
  CANNOT_ASSIGN_NODE = "CANNOT_ASSIGN_NODE",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  INVALID_MENU_ITEM = "INVALID_MENU_ITEM",
  NOT_FOUND = "NOT_FOUND",
  NO_MENU_ITEM_PROVIDED = "NO_MENU_ITEM_PROVIDED",
  REQUIRED = "REQUIRED",
  TOO_MANY_MENU_ITEMS = "TOO_MANY_MENU_ITEMS",
  UNIQUE = "UNIQUE",
}

export enum MenuSortField {
  ITEMS_COUNT = "ITEMS_COUNT",
  NAME = "NAME",
}

export enum MetadataErrorCode {
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
}

export enum OrderAction {
  CAPTURE = "CAPTURE",
  MARK_AS_PAID = "MARK_AS_PAID",
  REFUND = "REFUND",
  VOID = "VOID",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum OrderErrorCode {
  BILLING_ADDRESS_NOT_SET = "BILLING_ADDRESS_NOT_SET",
  CANNOT_CANCEL_FULFILLMENT = "CANNOT_CANCEL_FULFILLMENT",
  CANNOT_CANCEL_ORDER = "CANNOT_CANCEL_ORDER",
  CANNOT_DELETE = "CANNOT_DELETE",
  CANNOT_REFUND = "CANNOT_REFUND",
  CAN_NOT_UPDATE = "CAN_NOT_UPDATE",
  CAPTURE_INACTIVE_PAYMENT = "CAPTURE_INACTIVE_PAYMENT",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  FULFILL_ORDER_LINE = "FULFILL_ORDER_LINE",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INSUFFICIENT_STOCK = "INSUFFICIENT_STOCK",
  INVALID = "INVALID",
  NOT_EDITABLE = "NOT_EDITABLE",
  NOT_FOUND = "NOT_FOUND",
  ORDER_NO_SHIPPING_ADDRESS = "ORDER_NO_SHIPPING_ADDRESS",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  PAYMENT_MISSING = "PAYMENT_MISSING",
  PRODUCT_NOT_PUBLISHED = "PRODUCT_NOT_PUBLISHED",
  PRODUCT_UNAVAILABLE_FOR_PURCHASE = "PRODUCT_UNAVAILABLE_FOR_PURCHASE",
  REQUIRED = "REQUIRED",
  SHIPPING_METHOD_NOT_APPLICABLE = "SHIPPING_METHOD_NOT_APPLICABLE",
  SHIPPING_METHOD_REQUIRED = "SHIPPING_METHOD_REQUIRED",
  TAX_ERROR = "TAX_ERROR",
  UNIQUE = "UNIQUE",
  VOID_INACTIVE_PAYMENT = "VOID_INACTIVE_PAYMENT",
  ZERO_QUANTITY = "ZERO_QUANTITY",
}

export enum OrderEventsEmailsEnum {
  CONFIRMED = "CONFIRMED",
  DELIVERY_CONFIRMATION = "DELIVERY_CONFIRMATION",
  DIGITAL_LINKS = "DIGITAL_LINKS",
  FULFILLMENT_CONFIRMATION = "FULFILLMENT_CONFIRMATION",
  ORDER_CANCEL = "ORDER_CANCEL",
  ORDER_CONFIRMATION = "ORDER_CONFIRMATION",
  ORDER_REFUND = "ORDER_REFUND",
  PAYMENT_CONFIRMATION = "PAYMENT_CONFIRMATION",
  SHIPPING_CONFIRMATION = "SHIPPING_CONFIRMATION",
  TRACKING_UPDATED = "TRACKING_UPDATED",
}

export enum OrderEventsEnum {
  CANCELED = "CANCELED",
  CONFIRMED = "CONFIRMED",
  DRAFT_ADDED_PRODUCTS = "DRAFT_ADDED_PRODUCTS",
  DRAFT_CREATED = "DRAFT_CREATED",
  DRAFT_REMOVED_PRODUCTS = "DRAFT_REMOVED_PRODUCTS",
  EMAIL_SENT = "EMAIL_SENT",
  EXTERNAL_SERVICE_NOTIFICATION = "EXTERNAL_SERVICE_NOTIFICATION",
  FULFILLMENT_CANCELED = "FULFILLMENT_CANCELED",
  FULFILLMENT_FULFILLED_ITEMS = "FULFILLMENT_FULFILLED_ITEMS",
  FULFILLMENT_RESTOCKED_ITEMS = "FULFILLMENT_RESTOCKED_ITEMS",
  HANGUP = "HANGUP",
  INVOICE_GENERATED = "INVOICE_GENERATED",
  INVOICE_REQUESTED = "INVOICE_REQUESTED",
  INVOICE_SENT = "INVOICE_SENT",
  INVOICE_UPDATED = "INVOICE_UPDATED",
  NOTE_ADDED = "NOTE_ADDED",
  ORDER_FULLY_PAID = "ORDER_FULLY_PAID",
  ORDER_MARKED_AS_PAID = "ORDER_MARKED_AS_PAID",
  OTHER = "OTHER",
  OVERSOLD_ITEMS = "OVERSOLD_ITEMS",
  PAYMENT_AUTHORIZED = "PAYMENT_AUTHORIZED",
  PAYMENT_CAPTURED = "PAYMENT_CAPTURED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_REFUNDED = "PAYMENT_REFUNDED",
  PAYMENT_VOIDED = "PAYMENT_VOIDED",
  PLACED = "PLACED",
  PLACED_FROM_DRAFT = "PLACED_FROM_DRAFT",
  TRACKING_UPDATED = "TRACKING_UPDATED",
  UPDATED_ADDRESS = "UPDATED_ADDRESS",
  UPDATE_EXTRACHARGE = "UPDATE_EXTRACHARGE",
}

export enum OrderPaymentFilter {
  FULLY_PAID = "FULLY_PAID",
  UNPAID = "UNPAID",
}

export enum OrderRefercodeFilter {
  REFER_CODE = "REFER_CODE",
}

export enum OrderSortField {
  CREATION_DATE = "CREATION_DATE",
  CUSTOMER = "CUSTOMER",
  FULFILLMENT_STATUS = "FULFILLMENT_STATUS",
  NUMBER = "NUMBER",
  PAYMENT = "PAYMENT",
  TOTAL = "TOTAL",
}

export enum OrderStatus {
  CANCELED = "CANCELED",
  DELIVERED = "DELIVERED",
  DRAFT = "DRAFT",
  FULFILLED = "FULFILLED",
  HANGUP = "HANGUP",
  PARTIALLY_FULFILLED = "PARTIALLY_FULFILLED",
  PENDING = "PENDING",
  UNFULFILLED = "UNFULFILLED",
}

export enum OrderStatusFilter {
  CANCELED = "CANCELED",
  FULFILLED = "FULFILLED",
  PARTIALLY_FULFILLED = "PARTIALLY_FULFILLED",
  PENDING = "PENDING",
  READY_TO_CAPTURE = "READY_TO_CAPTURE",
  READY_TO_FULFILL = "READY_TO_FULFILL",
  UNFULFILLED = "UNFULFILLED",
}

export enum PageErrorCode {
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum PageHeaderEventsEnum {
  OTHER = "OTHER",
  PAGE_HEADER_APPLIED = "PAGE_HEADER_APPLIED",
  PAGE_HEADER_CREATED = "PAGE_HEADER_CREATED",
  PAGE_HEADER_DELETED = "PAGE_HEADER_DELETED",
  PAGE_HEADER_UPDATED = "PAGE_HEADER_UPDATED",
}

export enum PageHeaderLocatedEnum {
  BOTTOM = "BOTTOM",
  CHECKOUT = "CHECKOUT",
  FLOAT = "FLOAT",
  TOP = "TOP",
}

export enum PageHeaderSortField {
  CREATION_DATE = "CREATION_DATE",
  ID = "ID",
  NAME = "NAME",
}

export enum PageSortField {
  CREATION_DATE = "CREATION_DATE",
  PUBLICATION_DATE = "PUBLICATION_DATE",
  SLUG = "SLUG",
  TITLE = "TITLE",
  VISIBILITY = "VISIBILITY",
}

export enum PageUserEventsEnum {
  CREATE_PAGE = "CREATE_PAGE",
  RELEASE_PAGE = "RELEASE_PAGE",
  REMOVE_PAGE = "REMOVE_PAGE",
  UPDATE_PAGE = "UPDATE_PAGE",
}

export enum PaymentChargeStatusEnum {
  CANCELLED = "CANCELLED",
  FULLY_CHARGED = "FULLY_CHARGED",
  FULLY_REFUNDED = "FULLY_REFUNDED",
  NOT_CHARGED = "NOT_CHARGED",
  PARTIALLY_CHARGED = "PARTIALLY_CHARGED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  PENDING = "PENDING",
  REFUSED = "REFUSED",
}

export enum PermissionEnum {
  MANAGE_APPS = "MANAGE_APPS",
  MANAGE_CATEGORY = "MANAGE_CATEGORY",
  MANAGE_CHECKOUTS = "MANAGE_CHECKOUTS",
  MANAGE_COMBOS = "MANAGE_COMBOS",
  MANAGE_CORNERMARK = "MANAGE_CORNERMARK",
  MANAGE_COUNTRY = "MANAGE_COUNTRY",
  MANAGE_COUPON_CODE = "MANAGE_COUPON_CODE",
  MANAGE_COVER = "MANAGE_COVER",
  MANAGE_CURRENCYRATE = "MANAGE_CURRENCYRATE",
  MANAGE_GIFT_CARD = "MANAGE_GIFT_CARD",
  MANAGE_HOTSEARCH = "MANAGE_HOTSEARCH",
  MANAGE_INSTAGRAM = "MANAGE_INSTAGRAM",
  MANAGE_INSTAGRAM_LABEL = "MANAGE_INSTAGRAM_LABEL",
  MANAGE_MENUS = "MANAGE_MENUS",
  MANAGE_ORDERS = "MANAGE_ORDERS",
  MANAGE_PAGES = "MANAGE_PAGES",
  MANAGE_PAYMENT = "MANAGE_PAYMENT",
  MANAGE_PERSONAL = "MANAGE_PERSONAL",
  MANAGE_PLUGINS = "MANAGE_PLUGINS",
  MANAGE_POPUP = "MANAGE_POPUP",
  MANAGE_PRODUCTACTIVATION = "MANAGE_PRODUCTACTIVATION",
  MANAGE_PRODUCTLENSTYPE = "MANAGE_PRODUCTLENSTYPE",
  MANAGE_PRODUCTS = "MANAGE_PRODUCTS",
  MANAGE_PRODUCTTAGS = "MANAGE_PRODUCTTAGS",
  MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES = "MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES",
  MANAGE_RECOMMENDATION_GROUP = "MANAGE_RECOMMENDATION_GROUP",
  MANAGE_REDEMPTIONS = "MANAGE_REDEMPTIONS",
  MANAGE_ROTARY = "MANAGE_ROTARY",
  MANAGE_SALES = "MANAGE_SALES",
  MANAGE_SERVICE_ACCOUNTS = "MANAGE_SERVICE_ACCOUNTS",
  MANAGE_SETTINGS = "MANAGE_SETTINGS",
  MANAGE_SHIPMENT = "MANAGE_SHIPMENT",
  MANAGE_SHIPPING = "MANAGE_SHIPPING",
  MANAGE_STAFF = "MANAGE_STAFF",
  MANAGE_SUBSCRIPTION = "MANAGE_SUBSCRIPTION",
  MANAGE_TRANSLATIONS = "MANAGE_TRANSLATIONS",
  MANAGE_USERS = "MANAGE_USERS",
  MANAGE_WAREHOUSE = "MANAGE_WAREHOUSE",
}

export enum PermissionGroupErrorCode {
  ASSIGN_NON_STAFF_MEMBER = "ASSIGN_NON_STAFF_MEMBER",
  CANNOT_REMOVE_FROM_LAST_GROUP = "CANNOT_REMOVE_FROM_LAST_GROUP",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  INVALID = "INVALID",
  LEFT_NOT_MANAGEABLE_PERMISSION = "LEFT_NOT_MANAGEABLE_PERMISSION",
  OUT_OF_SCOPE_PERMISSION = "OUT_OF_SCOPE_PERMISSION",
  OUT_OF_SCOPE_USER = "OUT_OF_SCOPE_USER",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum PermissionGroupSortField {
  NAME = "NAME",
}

export enum PermissionSiteErrorCode {
  ASSIGN_NON_STAFF_MEMBER = "ASSIGN_NON_STAFF_MEMBER",
  CANNOT_REMOVE_FROM_LAST_GROUP = "CANNOT_REMOVE_FROM_LAST_GROUP",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  INVALID = "INVALID",
  OUT_OF_SCOPE_USER = "OUT_OF_SCOPE_USER",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum PluginErrorCode {
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  PLUGIN_MISCONFIGURED = "PLUGIN_MISCONFIGURED",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum PluginSortField {
  IS_ACTIVE = "IS_ACTIVE",
  NAME = "NAME",
}

export enum PrescriptionStartSelectEnum {
  COLOUR = "COLOUR",
  COMBINATION = "COMBINATION",
  NONE = "NONE",
  YESNO = "YESNO",
}

export enum ProductErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  ATTRIBUTE_ALREADY_ASSIGNED = "ATTRIBUTE_ALREADY_ASSIGNED",
  ATTRIBUTE_CANNOT_BE_ASSIGNED = "ATTRIBUTE_CANNOT_BE_ASSIGNED",
  ATTRIBUTE_VARIANTS_DISABLED = "ATTRIBUTE_VARIANTS_DISABLED",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  NOT_PRODUCTS_IMAGE = "NOT_PRODUCTS_IMAGE",
  NOT_PRODUCTS_VARIANT = "NOT_PRODUCTS_VARIANT",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
  VARIANT_NO_DIGITAL_CONTENT = "VARIANT_NO_DIGITAL_CONTENT",
}

export enum ProductFieldEnum {
  AVAILABLE_FOR_PURCHASE = "AVAILABLE_FOR_PURCHASE",
  CATEGORY = "CATEGORY",
  CHARGE_TAXES = "CHARGE_TAXES",
  COLLECTIONS = "COLLECTIONS",
  COST_PRICE = "COST_PRICE",
  DESCRIPTION = "DESCRIPTION",
  NAME = "NAME",
  PRODUCT_IMAGES = "PRODUCT_IMAGES",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  PRODUCT_WEIGHT = "PRODUCT_WEIGHT",
  SEARCHABLE = "SEARCHABLE",
  VARIANT_IMAGES = "VARIANT_IMAGES",
  VARIANT_PRICE = "VARIANT_PRICE",
  VARIANT_SKU = "VARIANT_SKU",
  VARIANT_WEIGHT = "VARIANT_WEIGHT",
  VISIBLE = "VISIBLE",
}

export enum ProductLensTypeErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum ProductLensTypeTemplate {
  CLASSIC = "CLASSIC",
  PLUS = "PLUS",
}

export enum ProductOrderField {
  DATE = "DATE",
  MINIMAL_PRICE = "MINIMAL_PRICE",
  NAME = "NAME",
  PRICE = "PRICE",
  PUBLICATION_DATE = "PUBLICATION_DATE",
  PUBLISHED = "PUBLISHED",
  TYPE = "TYPE",
}

export enum ProductTagsErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum ProductTagsTagType {
  IMAGE = "IMAGE",
  TEXT = "TEXT",
}

export enum ProductTypeConfigurable {
  CONFIGURABLE = "CONFIGURABLE",
  SIMPLE = "SIMPLE",
}

export enum ProductTypeEnum {
  DIGITAL = "DIGITAL",
  SHIPPABLE = "SHIPPABLE",
}

export enum ProductTypeSortField {
  DIGITAL = "DIGITAL",
  NAME = "NAME",
  SHIPPING_REQUIRED = "SHIPPING_REQUIRED",
}

export enum RecommendSortField {
  CREATED = "CREATED",
  FROM_EMAIL = "FROM_EMAIL",
  ID = "ID",
  RECOMMEND_EMAIL = "RECOMMEND_EMAIL",
}

export enum RecommendationTargetTypeEnum {
  CATEGORY = "CATEGORY",
  COLLECTION = "COLLECTION",
  PRODUCT = "PRODUCT",
}

export enum RecommendationTypeEnum {
  ALSO_LIKE = "ALSO_LIKE",
  BUY_TOGETHER = "BUY_TOGETHER",
  RECOMMEND = "RECOMMEND",
}

export enum RotaryErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  COMPLETED = "COMPLETED",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  NOT_LOGIN = "NOT_LOGIN",
  NOT_STARTED = "NOT_STARTED",
  OVER_SUBSCRIBED = "OVER_SUBSCRIBED",
  REQUIRED = "REQUIRED",
  TYPE_ERROR = "TYPE_ERROR",
  UNIQUE = "UNIQUE",
}

export enum RotarySortField {
  CREATE_DATE = "CREATE_DATE",
  END_DATE = "END_DATE",
  IS_ENABLE = "IS_ENABLE",
  NUMBER = "NUMBER",
  START_DATE = "START_DATE",
  THEME = "THEME",
}

export enum RotaryTypeEnum {
  BANNER_BOX = "BANNER_BOX",
  BLIND_BOX = "BLIND_BOX",
  TURNTABLE = "TURNTABLE",
}

export enum SaleSortField {
  END_DATE = "END_DATE",
  NAME = "NAME",
  START_DATE = "START_DATE",
  TYPE = "TYPE",
  VALUE = "VALUE",
}

export enum SaleType {
  CUSTOM = "CUSTOM",
  DIRECT = "DIRECT",
  FIXED = "FIXED",
  FREE = "FREE",
  PERCENTAGE = "PERCENTAGE",
}

export enum SaleTypeEnum {
  EXCLUDE_PRODUCT = "EXCLUDE_PRODUCT",
  SPECIFIC_PRODUCT = "SPECIFIC_PRODUCT",
}

export enum SendgridWebhookSortField {
  TIME = "TIME",
}

export enum ShippingErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  MAX_LESS_THAN_MIN = "MAX_LESS_THAN_MIN",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum ShippingMethodTypeEnum {
  PRICE = "PRICE",
  WEIGHT = "WEIGHT",
}

export enum ShopErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  CANNOT_FETCH_TAX_RATES = "CANNOT_FETCH_TAX_RATES",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum SoldoutInCustompageSortField {
  CUSTOMPAGE_URL = "CUSTOMPAGE_URL",
}

export enum StaffMemberStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

export enum StockAvailability {
  IN_STOCK = "IN_STOCK",
  OUT_OF_STOCK = "OUT_OF_STOCK",
}

export enum StockErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum SubscriptionErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  DUPLICATED_INPUT_ITEM = "DUPLICATED_INPUT_ITEM",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum SubscriptionSortField {
  EMAIL = "EMAIL",
  ID = "ID",
  SUBSCRIBED = "SUBSCRIBED",
  UNSUBSCRIBED = "UNSUBSCRIBED",
}

export enum TagTypeEnum {
  IMAGE = "IMAGE",
  TEXT = "TEXT",
}

export enum UserOperatePageEventOperateType {
  CREATE_PAGE = "CREATE_PAGE",
  RELEASE_PAGE = "RELEASE_PAGE",
  REMOVE_PAGE = "REMOVE_PAGE",
  UPDATE_PAGE = "UPDATE_PAGE",
}

export enum UserSortField {
  DATE_JOINED = "DATE_JOINED",
  EMAIL = "EMAIL",
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  ORDER_COUNT = "ORDER_COUNT",
}

export enum VoucherDiscountType {
  FIXED = "FIXED",
  FREE = "FREE",
  PERCENTAGE = "PERCENTAGE",
  SHIPPING = "SHIPPING",
}

export enum VoucherSortField {
  CODE = "CODE",
  DISPALY_ORDER = "DISPALY_ORDER",
  END_DATE = "END_DATE",
  IS_OPEN = "IS_OPEN",
  MINIMUM_SPENT_AMOUNT = "MINIMUM_SPENT_AMOUNT",
  NAME = "NAME",
  START_DATE = "START_DATE",
  TYPE = "TYPE",
  USAGE_LIMIT = "USAGE_LIMIT",
  VALUE = "VALUE",
}

export enum VoucherTypeEnum {
  ENTIRE_ORDER = "ENTIRE_ORDER",
  EXCLUDE_PRODUCT = "EXCLUDE_PRODUCT",
  SHIPPING = "SHIPPING",
  SPECIFIC_PRODUCT = "SPECIFIC_PRODUCT",
}

export enum WarehouseErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum WarehouseSortField {
  NAME = "NAME",
}

export enum WebhookErrorCode {
  GRAPHQL_ERROR = "GRAPHQL_ERROR",
  INVALID = "INVALID",
  NOT_FOUND = "NOT_FOUND",
  REQUIRED = "REQUIRED",
  UNIQUE = "UNIQUE",
}

export enum WebhookEventTypeEnum {
  ANY_EVENTS = "ANY_EVENTS",
  CHECKOUT_CREATED = "CHECKOUT_CREATED",
  CHECKOUT_QUANTITY_CHANGED = "CHECKOUT_QUANTITY_CHANGED",
  CHECKOUT_UPDATED = "CHECKOUT_UPDATED",
  CUSTOMER_CREATED = "CUSTOMER_CREATED",
  FULFILLMENT_CREATED = "FULFILLMENT_CREATED",
  INVOICE_DELETED = "INVOICE_DELETED",
  INVOICE_REQUESTED = "INVOICE_REQUESTED",
  INVOICE_SENT = "INVOICE_SENT",
  ORDER_CANCELLED = "ORDER_CANCELLED",
  ORDER_CREATED = "ORDER_CREATED",
  ORDER_FULFILLED = "ORDER_FULFILLED",
  ORDER_FULLY_PAID = "ORDER_FULLY_PAID",
  ORDER_UPDATED = "ORDER_UPDATED",
  PRODUCT_CREATED = "PRODUCT_CREATED",
  PRODUCT_UPDATED = "PRODUCT_UPDATED",
}

export enum WebhookSortField {
  APP = "APP",
  NAME = "NAME",
  SERVICE_ACCOUNT = "SERVICE_ACCOUNT",
  TARGET_URL = "TARGET_URL",
}

export enum WeightUnitsEnum {
  G = "G",
  KG = "KG",
  LB = "LB",
  OZ = "OZ",
}

export interface AddPopupInput {
  name?: string | null;
  enable?: boolean | null;
  addPcImage?: string | null;
  addMbImage?: string | null;
  addLink?: string | null;
}

export interface AddressInput {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
  streetAddress1?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  cityArea?: string | null;
  postalCode?: string | null;
  country?: CountryCode | null;
  countryArea?: string | null;
  phone?: string | null;
  taxNumber?: string | null;
}

export interface AppFilterInput {
  search?: string | null;
  isActive?: boolean | null;
  type?: AppTypeEnum | null;
}

export interface AppInput {
  name?: string | null;
  isActive?: boolean | null;
  permissions?: (PermissionEnum | null)[] | null;
}

export interface AppInstallInput {
  appName?: string | null;
  manifestUrl?: string | null;
  activateAfterInstallation?: boolean | null;
  permissions?: (PermissionEnum | null)[] | null;
}

export interface AppSortingInput {
  direction: OrderDirection;
  field: AppSortField;
}

export interface AppTokenInput {
  name?: string | null;
  app: string;
}

export interface AttributeAssignInput {
  id: string;
  type: AttributeTypeEnum;
}

export interface AttributeCreateInput {
  inputType?: AttributeInputTypeEnum | null;
  name: string;
  slug?: string | null;
  showName: string;
  showType: AttributeShowTypeEnum;
  values?: (AttributeValueCreateInput | null)[] | null;
  valueRequired?: boolean | null;
  isVariantOnly?: boolean | null;
  visibleInStorefront?: boolean | null;
  filterableInStorefront?: boolean | null;
  filterableInDashboard?: boolean | null;
  storefrontSearchPosition?: number | null;
  availableInGrid?: boolean | null;
}

export interface AttributeFilterInput {
  valueRequired?: boolean | null;
  isVariantOnly?: boolean | null;
  visibleInStorefront?: boolean | null;
  filterableInStorefront?: boolean | null;
  filterableInDashboard?: boolean | null;
  availableInGrid?: boolean | null;
  search?: string | null;
  ids?: (string | null)[] | null;
  inCollection?: string | null;
  inCategory?: string | null;
}

export interface AttributeInput {
  slug: string;
  value?: string | null;
  values?: (string | null)[] | null;
}

export interface AttributeSortingInput {
  direction: OrderDirection;
  field: AttributeSortField;
}

export interface AttributeTranslationInput {
  name?: string | null;
  showName?: string | null;
}

export interface AttributeUpdateInput {
  name?: string | null;
  slug?: string | null;
  showName?: string | null;
  showType?: AttributeShowTypeEnum | null;
  removeValues?: (string | null)[] | null;
  addValues?: (AttributeValueCreateInput | null)[] | null;
  valueRequired?: boolean | null;
  isVariantOnly?: boolean | null;
  visibleInStorefront?: boolean | null;
  filterableInStorefront?: boolean | null;
  filterableInDashboard?: boolean | null;
  storefrontSearchPosition?: number | null;
  availableInGrid?: boolean | null;
}

export interface AttributeValueCreateInput {
  name: string;
  fromColor?: string | null;
  toColor?: string | null;
  colorThumbnail?: string | null;
}

export interface AttributeValueInput {
  id?: string | null;
  values: (string | null)[];
}

export interface AuthorizationKeyInput {
  key: string;
  password: string;
}

export interface CatalogueInput {
  variants?: (string | null)[] | null;
  products?: (string | null)[] | null;
  categories?: (string | null)[] | null;
  collections?: (string | null)[] | null;
  exclude?: boolean | null;
}

export interface CategoryFilterInput {
  search?: string | null;
  ids?: (string | null)[] | null;
}

export interface CategoryInput {
  description?: string | null;
  descriptionJson?: any | null;
  name?: string | null;
  slug?: string | null;
  seo?: SeoInput | null;
  backgroundImage?: any | null;
  backgroundImageAlt?: string | null;
}

export interface CategorySortingInput {
  direction: OrderDirection;
  field: CategorySortField;
}

export interface CollectionCreateInput {
  isPublished?: boolean | null;
  name?: string | null;
  url?: string | null;
  slug?: string | null;
  description?: string | null;
  descriptionJson?: any | null;
  backgroundImage?: any | null;
  backgroundImageAlt?: string | null;
  seo?: SeoInput | null;
  publicationDate?: any | null;
  usedFor?: CollectionUsedForEnum | null;
  displayOrder?: number | null;
  showPrompt?: boolean | null;
  promptText?: string | null;
  promptLink?: string | null;
  promptBackgroundColor?: string | null;
  promptTextColor?: string | null;
  promptArrowColor?: string | null;
  enablePopupMessage?: boolean | null;
  popupMessage?: string | null;
  products?: (string | null)[] | null;
}

export interface CollectionFilterInput {
  published?: CollectionPublished | null;
  search?: string | null;
  ids?: (string | null)[] | null;
  usedFor?: CollectionUsedForEnum | null;
}

export interface CollectionInput {
  isPublished?: boolean | null;
  name?: string | null;
  url?: string | null;
  slug?: string | null;
  description?: string | null;
  descriptionJson?: any | null;
  backgroundImage?: any | null;
  backgroundImageAlt?: string | null;
  seo?: SeoInput | null;
  publicationDate?: any | null;
  usedFor?: CollectionUsedForEnum | null;
  displayOrder?: number | null;
  showPrompt?: boolean | null;
  promptText?: string | null;
  promptLink?: string | null;
  promptBackgroundColor?: string | null;
  promptTextColor?: string | null;
  promptArrowColor?: string | null;
  enablePopupMessage?: boolean | null;
  popupMessage?: string | null;
}

export interface CollectionSortingInput {
  direction: OrderDirection;
  field: CollectionSortField;
}

export interface CollectionTranslationInput {
  seoTitle?: string | null;
  seoKeyword?: string | null;
  seoDescription?: string | null;
  name?: string | null;
  description?: string | null;
  descriptionJson?: any | null;
  promptText?: string | null;
  promptLink?: string | null;
  popupMessage?: string | null;
}

export interface ComboFilterInput {
  search?: string | null;
  name?: string | null;
  products?: string | null;
  enable?: boolean | null;
}

export interface ComboInput {
  name?: string | null;
  totalPrice?: any | null;
  labelText?: string | null;
  labelLink?: string | null;
  enable?: boolean | null;
}

export interface ComboSortingInput {
  direction: OrderDirection;
  field: ComboSortField;
}

export interface ComboTranslationInput {
  name?: string | null;
  labelText?: string | null;
  labelLink?: string | null;
}

export interface ConfigurationItemInput {
  name: string;
  value?: string | null;
}

export interface CornerMarkFilterInput {
  search?: string | null;
  created?: DateRangeInput | null;
  type?: CornerMarkTypeEnum | null;
}

export interface CornerMarkInput {
  title?: string | null;
  textColor?: string | null;
  type: CornerMarkTypeEnum;
  mainColor?: string | null;
  secondaryColor?: string | null;
}

export interface CornerMarkSortingInput {
  direction: OrderDirection;
  field: CornerMarkSortField;
}

export interface CornerMarkTranslationInput {
  title?: string | null;
}

export interface CountryFilterInput {
  enable?: boolean | null;
  search?: string | null;
  ids?: (string | null)[] | null;
}

export interface CountryInput {
  name: string;
  isoTwoCode: string;
  isoThreeCode: string;
  isoNumberCode: string;
  regions?: (RegionInput | null)[] | null;
  displayOrder?: number | null;
  enable?: boolean | null;
  defaultCurrency?: string | null;
  defaultLanguage?: string | null;
}

export interface CountrySortingInput {
  direction: OrderDirection;
  field: CountrySortField;
}

export interface CoverFilterInput {
  search?: string | null;
}

export interface CoverInput {
  name?: string | null;
  coverType?: CoverTypeEnum | null;
  title?: string | null;
  subtitle?: string | null;
  firstImagePc?: string | null;
  firstImageMb?: string | null;
  firstImageLink?: string | null;
  firstImageText?: string | null;
  secondImagePc?: string | null;
  secondImageMb?: string | null;
  secondImageLink?: string | null;
  secondImageText?: string | null;
  thirdImagePc?: string | null;
  thirdImageMb?: string | null;
  thirdImageLink?: string | null;
  thirdImageText?: string | null;
  fourthImagePc?: string | null;
  fourthImageMb?: string | null;
  fourthImageLink?: string | null;
  fourthImageText?: string | null;
  detailImagePc?: string | null;
  detailImageMb?: string | null;
  detailImageLink?: string | null;
  detailImageText?: string | null;
  detailLinkTargetPc?: string | null;
  detailLinkTargetMb?: string | null;
  products?: (string | null)[] | null;
  categories?: (string | null)[] | null;
}

export interface CoverSortingInput {
  direction: OrderDirection;
  field: CoverSortField;
}

export interface CurrencyrateCreateInput {
  code?: string | null;
  name?: string | null;
  symbol?: string | null;
  isPrimaryStoreCurrency?: boolean | null;
  isPrimaryExchangeRateCurrency?: boolean | null;
  isPublished?: boolean | null;
  displayOrder?: number | null;
  displayFormat?: string | null;
  rate?: number | null;
  conversionMethod?: ConversionMethodEnum | null;
}

export interface CurrencyrateFilterInput {
  isPrimaryStoreCurrency?: boolean | null;
  isPrimaryExchangeRateCurrency?: boolean | null;
  isPublished?: boolean | null;
  search?: string | null;
  ids?: (string | null)[] | null;
}

export interface CurrencyrateSortingInput {
  direction: OrderDirection;
  field: CurrencyrateSortField;
}

export interface CurrencyrateUpdateInput {
  code?: string | null;
  name?: string | null;
  symbol?: string | null;
  isPrimaryStoreCurrency?: boolean | null;
  isPrimaryExchangeRateCurrency?: boolean | null;
  isPublished?: boolean | null;
  displayOrder?: number | null;
  displayFormat?: string | null;
  rate?: number | null;
  conversionMethod?: ConversionMethodEnum | null;
}

export interface CustomerFilterInput {
  dateJoined?: DateRangeInput | null;
  moneySpent?: PriceRangeInput | null;
  numberOfOrders?: IntRangeInput | null;
  placedOrders?: DateRangeInput | null;
  search?: string | null;
  languageCode?: (LanguageCodeFilter | null)[] | null;
  registerSite?: string | null;
  registerSourse?: string | null;
  fromReferral?: string | null;
  lastIpCountry?: string | null;
}

export interface CustomerInput {
  defaultBillingAddress?: AddressInput | null;
  defaultShippingAddress?: AddressInput | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  isActive?: boolean | null;
  isSubscribed?: boolean | null;
  note?: string | null;
  gender?: string | null;
  birthday?: any | null;
  countryArea?: string | null;
  phone?: string | null;
}

export interface DateRangeInput {
  gte?: any | null;
  lte?: any | null;
}

export interface DateTimeRangeInput {
  gte?: any | null;
  lte?: any | null;
}

export interface DraftOrderInput {
  billingAddress?: AddressInput | null;
  user?: string | null;
  userEmail?: string | null;
  discount?: any | null;
  shippingAddress?: AddressInput | null;
  shippingMethod?: string | null;
  voucher?: string | null;
  customerNote?: string | null;
}

export interface EmailSettingUpdateInput {
  sendFrequency: number;
  template?: string | null;
  subject?: string | null;
}

export interface ExportInfoInput {
  attributes?: string[] | null;
  warehouses?: string[] | null;
  fields?: ProductFieldEnum[] | null;
}

export interface ExportProductsInput {
  scope: ExportScope;
  filter?: ProductFilterInput | null;
  ids?: string[] | null;
  exportInfo?: ExportInfoInput | null;
  fileType: FileTypesEnum;
}

export interface ExportSubscriptionsInput {
  scope: ExportSubscriptionScope;
  filter?: SubscriptionFilterInput | null;
  ids?: string[] | null;
  fileType: FileTypesEnum;
}

export interface ExtraChargeTranslationInput {
  name?: string | null;
  desc?: string | null;
  subName?: string | null;
  subDesc?: string | null;
}

export interface FulfillmentCancelInput {
  warehouseId: string;
}

export interface FulfillmentUpdateTrackingInput {
  trackingNumber?: string | null;
  notifyCustomer?: boolean | null;
}

export interface HotSearchCreateInput {
  hotWord: string;
  description?: string | null;
}

export interface HotSearchTranslationInput {
  hotWord?: string | null;
  description?: string | null;
}

export interface HotSearchUpdateInput {
  hotWord: string;
  description?: string | null;
}

export interface InsTagCreateInput {
  pcx?: any | null;
  pcy?: any | null;
  mbx?: any | null;
  mby?: any | null;
  productvariant?: string | null;
}

export interface InsTagUpdateInput {
  pcx?: any | null;
  pcy?: any | null;
  mbx?: any | null;
  mby?: any | null;
  productvariant?: string | null;
  id?: string | null;
}

export interface InstagramCommentFilterInput {
  search?: string | null;
  isVisible?: boolean | null;
  source?: (CommentSourceTypeEnum | null)[] | null;
  parentType?: (CommentParentTypeEnum | null)[] | null;
}

export interface InstagramCommentSortingInput {
  direction: OrderDirection;
  field: InstagramCommentSortFidls;
}

export interface InstagramLabelInput {
  name?: string | null;
}

export interface InstagramLabelSortingInput {
  direction: OrderDirection;
  field: InstagramLabelSortFidls;
}

export interface InstagramSortingInput {
  direction: OrderDirection;
  field: InstagramSortFidls;
}

export interface InstagramTypeFilterInput {
  search?: string | null;
  platForm?: (ContentPlatformEnum | null)[] | null;
  published?: boolean | null;
  createTime?: DateRangeInput | null;
}

export interface InstagramUpdateInput {
  published?: boolean | null;
  startTime?: number | null;
  intervalTime?: number | null;
}

export interface IntRangeInput {
  gte?: number | null;
  lte?: number | null;
}

export interface LoginPopupCreateInput {
  title: string;
  coupon: string;
  Button: string;
  pcUrl: string;
  mbUrl: string;
  pcThumbnail: string;
  mbThumbnail: string;
  couponCode: (string | null)[];
  couponValue: any;
  buttonValue: any;
  popupType?: LoginPopupPopupTypeEnum | null;
  subTitle?: string | null;
  isEnable: boolean;
  isAffUse: boolean;
  textColor?: string | null;
  buttonTextColor?: string | null;
  buttonBackgroudColor?: string | null;
  buttonBorderColor?: string | null;
  pcSuccessful?: string | null;
  mbSuccessful?: string | null;
  successfulLink?: string | null;
  pcSuccessfulLinkTarget?: string | null;
  mbSuccessfulLinkTarget?: string | null;
  popupUpMinutes?: number | null;
}

export interface LoginPopupTranslationInput {
  title?: string | null;
  subTitle?: string | null;
  coupon?: string | null;
  Button?: string | null;
  pcUrl?: string | null;
  mbUrl?: string | null;
  couponCode?: string | null;
}

export interface MenuBannerInput {
  id?: string | null;
  type?: MenuBannerTypeEnum | null;
  title?: string | null;
  subtitle?: string | null;
  url?: string | null;
  pcImageUrl?: string | null;
  h5ImageUrl?: string | null;
}

export interface MenuBannerTranslationInput {
  title?: string | null;
  subtitle?: string | null;
  url?: string | null;
  pcImageUrl?: string | null;
  h5ImageUrl?: string | null;
}

export interface MenuCreateInput {
  name: string;
  slug?: string | null;
  items?: (MenuItemInput | null)[] | null;
}

export interface MenuItemCreateInput {
  name: string;
  url?: string | null;
  category?: string | null;
  collection?: string | null;
  page?: string | null;
  thumbnailUrl?: string | null;
  mbThumbnailUrl?: string | null;
  menuBanner?: (MenuBannerInput | null)[] | null;
  cellNumber?: number | null;
  textColor?: string | null;
  isTop?: boolean | null;
  isShowName?: boolean | null;
  menu: string;
  parent?: string | null;
  items?: (MenuItemInput | null)[] | null;
}

export interface MenuItemFilterInput {
  search?: string | null;
}

export interface MenuItemInput {
  name?: string | null;
  url?: string | null;
  category?: string | null;
  collection?: string | null;
  page?: string | null;
  thumbnailUrl?: string | null;
  mbThumbnailUrl?: string | null;
  menuBanner?: (MenuBannerInput | null)[] | null;
  cellNumber?: number | null;
  textColor?: string | null;
  isTop?: boolean | null;
  isShowName?: boolean | null;
}

export interface MenuItemMoveInput {
  itemId: string;
  parentId?: string | null;
  sortOrder?: number | null;
}

export interface MenuItemTranslationInput {
  name?: string | null;
  url?: string | null;
  thumbnailUrl?: string | null;
  mbThumbnailUrl?: string | null;
}

export interface MenuSortingInput {
  direction: OrderDirection;
  field: MenuSortField;
}

export interface MetadataInput {
  key: string;
  value: string;
}

export interface MoveAddPopupVariantInput {
  addpopupVariantId: string;
  sortOrder?: number | null;
}

export interface MoveComboProductInput {
  comboProductId: string;
  sortOrder?: number | null;
}

export interface MoveProductInput {
  productId: string;
  sortOrder?: number | null;
}

export interface MoveRedemptionVariantInput {
  redemptionVariantId: string;
  sortOrder?: number | null;
}

export interface MoveSaleProductInput {
  saleProductId: string;
  sortOrder?: number | null;
}

export interface MoveSaleVariantInput {
  saleVariantId: string;
  sortOrder?: number | null;
}

export interface NameTranslationInput {
  name?: string | null;
}

export interface OrderAddNoteInput {
  message: string;
}

export interface OrderDraftFilterInput {
  customer?: string | null;
  created?: DateRangeInput | null;
  search?: string | null;
  couponcode?: string | null;
}

export interface OrderFilterInput {
  paymentStatus?: (PaymentChargeStatusEnum | null)[] | null;
  status?: (OrderStatusFilter | null)[] | null;
  customer?: string | null;
  created?: DateRangeInput | null;
  search?: string | null;
  payment?: (OrderPaymentFilter | null)[] | null;
  couponcode?: string | null;
  languageCode?: (LanguageCodeFilter | null)[] | null;
  referralCode?: string | null;
  recommendCode?: string | null;
  referCode?: (OrderRefercodeFilter | null)[] | null;
}

export interface OrderFulfillInput {
  lines: OrderFulfillLineInput[];
  notifyCustomer?: boolean | null;
}

export interface OrderFulfillLineInput {
  orderLineId?: string | null;
  stocks: OrderFulfillStockInput[];
}

export interface OrderFulfillStockInput {
  quantity: number;
  warehouse: string;
}

export interface OrderLineCreateInput {
  quantity: number;
  variantId: string;
}

export interface OrderLineInput {
  quantity: number;
}

export interface OrderSortingInput {
  direction: OrderDirection;
  field: OrderSortField;
}

export interface OrderUpdateInput {
  billingAddress?: AddressInput | null;
  userEmail?: string | null;
  shippingAddress?: AddressInput | null;
}

export interface OrderUpdateShippingInput {
  shippingMethod?: string | null;
}

export interface PageFilterInput {
  search?: string | null;
}

export interface PageFooterCreateInput {
  mediaPlatform?: any | null;
  paymentMethod?: any | null;
  customerService?: string | null;
  wholesaleInquiries?: string | null;
}

export interface PageHeaderFilterInput {
  search?: string | null;
  located?: PageHeaderLocatedEnum | null;
  isDefault?: boolean | null;
  countdown?: boolean | null;
}

export interface PageHeaderInput {
  extraData?: any | null;
  name?: string | null;
  located?: PageHeaderLocatedEnum | null;
  pcContent?: string | null;
  mobileContent?: string | null;
  isDefault?: boolean | null;
  startDate?: string | null;
  endDate?: string | null;
  countdown?: boolean | null;
  pcCountdown?: boolean | null;
  mbCountdown?: boolean | null;
  languageOpt?: boolean | null;
  isTop?: boolean | null;
  mainColor?: string | null;
  secondaryColor?: string | null;
  pcRollingDuration?: number | null;
  mbRollingDuration?: number | null;
}

export interface PageHeaderSortingInput {
  direction: OrderDirection;
  field: PageHeaderSortField;
}

export interface PageHeaderTranslationInput {
  name?: string | null;
  pcContent?: string | null;
  mobileContent?: string | null;
}

export interface PageInput {
  slug?: string | null;
  title?: string | null;
  content?: string | null;
  contentJson?: any | null;
  isPublished?: boolean | null;
  publicationDate?: string | null;
  seo?: SeoInput | null;
  url?: string | null;
}

export interface PageSortingInput {
  direction: OrderDirection;
  field: PageSortField;
}

export interface PageTranslationInput {
  seoTitle?: string | null;
  seoKeyword?: string | null;
  seoDescription?: string | null;
  title?: string | null;
  content?: string | null;
  contentJson?: any | null;
  metadata?: any | null;
}

export interface PermissionGroupCreateInput {
  addPermissions?: PermissionEnum[] | null;
  addUsers?: string[] | null;
  name: string;
}

export interface PermissionGroupFilterInput {
  search?: string | null;
}

export interface PermissionGroupSortingInput {
  direction: OrderDirection;
  field: PermissionGroupSortField;
}

export interface PermissionGroupUpdateInput {
  addPermissions?: PermissionEnum[] | null;
  addUsers?: string[] | null;
  name?: string | null;
  removePermissions?: PermissionEnum[] | null;
  removeUsers?: string[] | null;
}

export interface PermissionSiteInput {
  addUserids?: string[] | null;
}

export interface PermissionSiteUpdateInput {
  addUserids?: string[] | null;
  removeUserids?: string[] | null;
}

export interface PluginFilterInput {
  active?: boolean | null;
  search?: string | null;
}

export interface PluginSortingInput {
  direction: OrderDirection;
  field: PluginSortField;
}

export interface PluginUpdateInput {
  active?: boolean | null;
  configuration?: (ConfigurationItemInput | null)[] | null;
}

export interface PriceRangeInput {
  gte?: number | null;
  lte?: number | null;
}

export interface ProductActivationSettingInput {
  activationPcTitle: string;
  activationPcContent: string;
  activationPcSuccessedTitle: string;
  activationPcSuccessedContent: string;
  activationMbTitle: string;
  activationMbContent: string;
  activationMbSuccessedTitle: string;
  activationMbSuccessedContent: string;
  serialNumberPcContent: string;
  serialNumberMbContent: string;
  registerCouponPcBg: string;
  completeCouponPcBg: string;
  activationCouponPcBg: string;
  registerCouponMbBg: string;
  completeCouponMbBg: string;
  activationCouponMbBg: string;
}

export interface ProductActivationSettingTranslationInput {
  activationPcTitle?: string | null;
  activationPcContent?: string | null;
  activationPcSuccessedTitle?: string | null;
  activationPcSuccessedContent?: string | null;
  activationMbTitle?: string | null;
  activationMbContent?: string | null;
  activationMbSuccessedTitle?: string | null;
  activationMbSuccessedContent?: string | null;
  serialNumberPcContent?: string | null;
  serialNumberMbContent?: string | null;
}

export interface ProductCreateInput {
  attributes?: (AttributeValueInput | null)[] | null;
  publicationDate?: any | null;
  category?: string | null;
  chargeTaxes?: boolean | null;
  collections?: (string | null)[] | null;
  description?: string | null;
  descriptionJson?: any | null;
  isPublished?: boolean | null;
  name?: string | null;
  slug?: string | null;
  taxCode?: string | null;
  seo?: SeoInput | null;
  weight?: any | null;
  USP?: string | null;
  care?: string | null;
  sku?: string | null;
  trackInventory?: boolean | null;
  basePrice?: any | null;
  visibleInListings?: boolean | null;
  lensTypeTemplate?: LensTypeTemplateEnum | null;
  productType: string;
  stocks?: StockInput[] | null;
}

export interface ProductFilterInput {
  isPublished?: boolean | null;
  collections?: (string | null)[] | null;
  categories?: (string | null)[] | null;
  hasCategory?: boolean | null;
  attributes?: (AttributeInput | null)[] | null;
  stockAvailability?: StockAvailability | null;
  productType?: string | null;
  lensTypeTemplate?: LensTypeTemplateEnum | null;
  stocks?: ProductStockFilterInput | null;
  search?: string | null;
  price?: PriceRangeInput | null;
  minimalPrice?: PriceRangeInput | null;
  productTypes?: (string | null)[] | null;
  ids?: (string | null)[] | null;
}

export interface ProductInput {
  attributes?: (AttributeValueInput | null)[] | null;
  publicationDate?: any | null;
  category?: string | null;
  chargeTaxes?: boolean | null;
  collections?: (string | null)[] | null;
  description?: string | null;
  descriptionJson?: any | null;
  isPublished?: boolean | null;
  name?: string | null;
  slug?: string | null;
  taxCode?: string | null;
  seo?: SeoInput | null;
  weight?: any | null;
  USP?: string | null;
  care?: string | null;
  sku?: string | null;
  trackInventory?: boolean | null;
  basePrice?: any | null;
  visibleInListings?: boolean | null;
  lensTypeTemplate?: LensTypeTemplateEnum | null;
}

export interface ProductLensTypeCreateInput {
  name: string;
  extraChargeCode?: string | null;
  skuStartCode?: string | null;
  isActive?: boolean | null;
  prescriptionStartSelect?: PrescriptionStartSelectEnum | null;
}

export interface ProductOrder {
  direction: OrderDirection;
  attributeId?: string | null;
  field?: ProductOrderField | null;
}

export interface ProductStockFilterInput {
  warehouseIds?: string[] | null;
  quantity?: IntRangeInput | null;
}

export interface ProductTagsCreateInput {
  name?: string | null;
  tagType?: TagTypeEnum | null;
  title: string;
  stickersImage?: string | null;
  stickersImageLocationX?: number | null;
  stickersImageLocationY?: number | null;
  showTag?: boolean | null;
  componentFontColor?: string | null;
  productFontColor?: string | null;
  productBackgroundColor?: string | null;
}

export interface ProductTagsFilterInput {
  search?: string | null;
}

export interface ProductTranslationInput {
  seoTitle?: string | null;
  seoKeyword?: string | null;
  seoDescription?: string | null;
  name?: string | null;
  description?: string | null;
  descriptionJson?: any | null;
  USP?: string | null;
  care?: string | null;
  metadata?: any | null;
}

export interface ProductTypeFilterInput {
  search?: string | null;
  configurable?: ProductTypeConfigurable | null;
  productType?: ProductTypeEnum | null;
  ids?: (string | null)[] | null;
}

export interface ProductTypeInput {
  name?: string | null;
  slug?: string | null;
  hasVariants?: boolean | null;
  productAttributes?: (string | null)[] | null;
  variantAttributes?: (string | null)[] | null;
  skuAttributes?: (string | null)[] | null;
  isShippingRequired?: boolean | null;
  isDigital?: boolean | null;
  weight?: any | null;
  taxCode?: string | null;
}

export interface ProductTypeSortingInput {
  direction: OrderDirection;
  field: ProductTypeSortField;
}

export interface ProductVariantBulkCreateInput {
  attributes: (AttributeValueInput | null)[];
  skuAttributes?: (AttributeValueInput | null)[] | null;
  costPrice?: any | null;
  price?: any | null;
  sku: string;
  trackInventory?: boolean | null;
  weight?: any | null;
  extraCharge?: any | null;
  isPublished?: boolean | null;
  publicationDate?: any | null;
  cornerMark?: string | null;
  fromColor?: string | null;
  toColor?: string | null;
  colorThumbnail?: string | null;
  isTwoColor?: boolean | null;
  colorTagText?: string | null;
  colorTagTextColor?: string | null;
  colorTagBackground?: string | null;
  colorTagIcon?: string | null;
  shortDescription?: string | null;
  fullDescription?: string | null;
  framesImg?: string | null;
  framesVideo?: string | null;
  describe?: string | null;
  skuName?: string | null;
  slug?: string | null;
  seo?: SeoInput | null;
  USP?: string | null;
  extrachargeCategoryName?: string | null;
  extrachargeCategory?: string | null;
  stocks?: StockInput[] | null;
}

export interface ProductVariantCreateInput {
  attributes: (AttributeValueInput | null)[];
  skuAttributes?: (AttributeValueInput | null)[] | null;
  costPrice?: any | null;
  price?: any | null;
  sku?: string | null;
  trackInventory?: boolean | null;
  weight?: any | null;
  extraCharge?: any | null;
  isPublished?: boolean | null;
  publicationDate?: any | null;
  cornerMark?: string | null;
  fromColor?: string | null;
  toColor?: string | null;
  colorThumbnail?: string | null;
  isTwoColor?: boolean | null;
  colorTagText?: string | null;
  colorTagTextColor?: string | null;
  colorTagBackground?: string | null;
  colorTagIcon?: string | null;
  shortDescription?: string | null;
  fullDescription?: string | null;
  framesImg?: string | null;
  framesVideo?: string | null;
  describe?: string | null;
  skuName?: string | null;
  slug?: string | null;
  seo?: SeoInput | null;
  USP?: string | null;
  extrachargeCategoryName?: string | null;
  extrachargeCategory?: string | null;
  product: string;
  stocks?: StockInput[] | null;
}

export interface ProductVariantFilterInput {
  search?: string | null;
  sku?: (string | null)[] | null;
  attributes?: (AttributeInput | null)[] | null;
  skuattributes?: (AttributeInput | null)[] | null;
  spuattributes?: (AttributeInput | null)[] | null;
  ids?: (string | null)[] | null;
  categories?: (string | null)[] | null;
  countryCode?: string | null;
  stockAvailability?: StockAvailability | null;
}

export interface ProductVariantInput {
  attributes?: (AttributeValueInput | null)[] | null;
  skuAttributes?: (AttributeValueInput | null)[] | null;
  costPrice?: any | null;
  price?: any | null;
  sku?: string | null;
  trackInventory?: boolean | null;
  weight?: any | null;
  extraCharge?: any | null;
  isPublished?: boolean | null;
  publicationDate?: any | null;
  cornerMark?: string | null;
  fromColor?: string | null;
  toColor?: string | null;
  colorThumbnail?: string | null;
  isTwoColor?: boolean | null;
  colorTagText?: string | null;
  colorTagTextColor?: string | null;
  colorTagBackground?: string | null;
  colorTagIcon?: string | null;
  shortDescription?: string | null;
  fullDescription?: string | null;
  framesImg?: string | null;
  framesVideo?: string | null;
  describe?: string | null;
  skuName?: string | null;
  slug?: string | null;
  seo?: SeoInput | null;
  USP?: string | null;
  extrachargeCategoryName?: string | null;
  extrachargeCategory?: string | null;
}

export interface ProductVariantTranslationInput {
  seoTitle?: string | null;
  seoKeyword?: string | null;
  seoDescription?: string | null;
  name?: string | null;
  skuName?: string | null;
  fullDescription?: string | null;
  shortDescription?: string | null;
  describe?: string | null;
  USP?: string | null;
  metadata?: any | null;
}

export interface RangeInput {
  products?: (string | null)[] | null;
  categories?: (string | null)[] | null;
}

export interface RecommendFilterInput {
  search?: string | null;
  created?: DateTimeRangeInput | null;
}

export interface RecommendPopupInput {
  recommendUrl: string;
  isEnable?: boolean | null;
  fromVoucher?: string | null;
  recommendVoucher?: string | null;
  formVoucherText?: string | null;
  formImagePc?: string | null;
  formImageMb?: string | null;
  recommendVoucherText?: string | null;
  recommendImagePc?: string | null;
  recommendImageMb?: string | null;
  emailSubject?: string | null;
  emailContent?: string | null;
  defaultMessage?: string | null;
  facebookMessage?: string | null;
}

export interface RecommendSortingInput {
  direction: OrderDirection;
  field: RecommendSortField;
}

export interface RedemptionInput {
  name?: string | null;
  description?: string | null;
  minOrderAmount?: any | null;
  enable?: boolean | null;
  maxRedemptionAmount?: any | null;
  signText?: string | null;
}

export interface RedemptionVariantInput {
  variantId: string;
  discountPrice?: any | null;
  sortOrder?: number | null;
}

export interface RegionInput {
  name: string;
  code?: string | null;
  displayOrder?: number | null;
  enable?: boolean | null;
  country?: string | null;
}

export interface ReorderInput {
  id: string;
  sortOrder?: number | null;
}

export interface RotaryFilterInput {
  isEnable?: boolean | null;
  search?: string | null;
  ids?: (string | null)[] | null;
  saleType?: RotaryTypeEnum | null;
}

export interface RotaryInput {
  theme: string;
  number: number;
  isEnable?: boolean | null;
  isAffUse: boolean;
  items?: (RotaryItemsInput | null)[] | null;
  startDate?: any | null;
  endDate?: any | null;
  rotaryType?: RotaryTypeEnum | null;
  titleText?: string | null;
  subtitleText?: string | null;
  citationText?: string | null;
  rulesText?: string | null;
  titleImage?: string | null;
  subtitleImage?: string | null;
  backgroundImage?: string | null;
  subjectImage?: string | null;
  voucherImage?: string | null;
  titleImageMb?: string | null;
  subtitleImageMb?: string | null;
  backgroundImageMb?: string | null;
  subjectImageMb?: string | null;
  voucherImageMb?: string | null;
  backgroundFromColor?: string | null;
  backgroundToColor?: string | null;
  buttomFromColor?: string | null;
  buttomToColor?: string | null;
  buttomTextColor?: string | null;
  subjectTextColor?: string | null;
  buttomFrameColor?: string | null;
  inputFrameColor?: string | null;
  rotaryTextColor?: string | null;
  voucherTextColor?: string | null;
  thumbnailPc?: string | null;
  thumbnailMb?: string | null;
  pointerImage?: string | null;
  pointerImageMb?: string | null;
  coreImage?: string | null;
  coreImageMb?: string | null;
  tasselsImage?: string | null;
  tasselsImageMb?: string | null;
  limitImage?: string | null;
  limitImageMb?: string | null;
  endImage?: string | null;
  endImageMb?: string | null;
}

export interface RotaryItemsInput {
  probability?: number | null;
  text?: string | null;
  voucher?: string | null;
  fromRotary?: string | null;
}

export interface RotarySortingInput {
  direction: OrderDirection;
  field: RotarySortField;
}

export interface SaleFilterInput {
  status?: (DiscountStatusEnum | null)[] | null;
  saleType?: DiscountValueTypeEnum | null;
  started?: DateTimeRangeInput | null;
  search?: string | null;
  languageCode?: (LanguageCodeFilter | null)[] | null;
}

export interface SaleInput {
  name?: string | null;
  type?: DiscountValueTypeEnum | null;
  rangeType?: SaleTypeEnum | null;
  value?: any | null;
  products?: (string | null)[] | null;
  prescriptionRequired?: boolean | null;
  categories?: (string | null)[] | null;
  collections?: (string | null)[] | null;
  languages?: (string | null)[] | null;
  startDate?: any | null;
  endDate?: any | null;
  cornerMark?: string | null;
  onlyBuyOne?: boolean | null;
  showSuperPrice?: boolean | null;
  showOriginalPrice?: boolean | null;
  superName?: string | null;
  superPriceText?: string | null;
  superPriceImage?: string | null;
  superPriceImageMb?: string | null;
}

export interface SaleProductInput {
  productId: string;
  usageLimit?: number | null;
  discountPrice?: any | null;
  sortOrder?: number | null;
}

export interface SaleSortingInput {
  direction: OrderDirection;
  field: SaleSortField;
}

export interface SaleTranslationInput {
  name?: string | null;
  superName?: string | null;
  superPriceText?: string | null;
  superPriceImage?: string | null;
  superPriceImageMb?: string | null;
}

export interface SaleVariantInput {
  variantId: string;
  usageLimit?: number | null;
  discountPrice?: any | null;
  sortOrder?: number | null;
}

export interface SendgridWebhookSortingInput {
  direction: OrderDirection;
  field: SendgridWebhookSortField;
}

export interface SeoInput {
  title?: string | null;
  keyword?: string | null;
  description?: string | null;
}

export interface ShipmentFilterInput {
  search?: string | null;
}

export interface ShippingMethodTranslationInput {
  name?: string | null;
  instructions?: string | null;
}

export interface ShippingPriceInput {
  name?: string | null;
  price?: any | null;
  minimumOrderPrice?: any | null;
  maximumOrderPrice?: any | null;
  minimumOrderWeight?: any | null;
  maximumOrderWeight?: any | null;
  type?: ShippingMethodTypeEnum | null;
  shippingZone?: string | null;
  instructions?: string | null;
}

export interface ShippingZoneCreateInput {
  name?: string | null;
  countries?: (string | null)[] | null;
  default?: boolean | null;
  addWarehouses?: (string | null)[] | null;
}

export interface ShippingZoneUpdateInput {
  name?: string | null;
  countries?: (string | null)[] | null;
  default?: boolean | null;
  addWarehouses?: (string | null)[] | null;
  removeWarehouses?: (string | null)[] | null;
}

export interface ShopSettingsInput {
  headerText?: string | null;
  title?: string | null;
  description?: string | null;
  keywords?: string | null;
  shopApiUri?: string | null;
  shopViewPageManageUri?: string | null;
  includeTaxesInPrices?: boolean | null;
  displayGrossPrices?: boolean | null;
  chargeTaxesOnShipping?: boolean | null;
  trackInventoryByDefault?: boolean | null;
  defaultWeightUnit?: WeightUnitsEnum | null;
  automaticFulfillmentDigitalProducts?: boolean | null;
  defaultDigitalMaxDownloads?: number | null;
  defaultDigitalUrlValidDays?: number | null;
  defaultMailSenderName?: string | null;
  defaultMailSenderAddress?: string | null;
  customerSetPasswordUrl?: string | null;
}

export interface ShopSettingsTranslationInput {
  headerText?: string | null;
  description?: string | null;
  title?: string | null;
  keywords?: string | null;
}

export interface SiteDomainInput {
  domain?: string | null;
  name?: string | null;
}

export interface SiteLanguageInput {
  name?: string | null;
  domain?: string | null;
  language?: string | null;
  isActive?: boolean | null;
  checkoutPopupImage?: string | null;
}

export interface SoldoutInCustompageFilterInput {
  search?: string | null;
  isPublished?: boolean | null;
  trackInventory?: boolean | null;
}

export interface SoldoutInCustompageSortingInput {
  direction: OrderDirection;
  field: SoldoutInCustompageSortField;
}

export interface StaffCreateInput {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  isActive?: boolean | null;
  isSubscribed?: boolean | null;
  note?: string | null;
  addGroups?: string[] | null;
  redirectUrl?: string | null;
}

export interface StaffUpdateInput {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  isActive?: boolean | null;
  isSubscribed?: boolean | null;
  note?: string | null;
  addGroups?: string[] | null;
  removeGroups?: string[] | null;
}

export interface StaffUserInput {
  status?: StaffMemberStatus | null;
  search?: string | null;
}

export interface StockInput {
  warehouse: string;
  quantity?: number | null;
}

export interface SubscriptionFilterInput {
  search?: string | null;
  isSubscription?: boolean | null;
}

export interface SubscriptionInput {
  email?: string | null;
  active?: boolean | null;
}

export interface SubscriptionSortingInput {
  direction: OrderDirection;
  field: SubscriptionSortField;
}

export interface TagsCatalogueInput {
  product?: (string | null)[] | null;
  productvariant?: (string | null)[] | null;
  categories?: (string | null)[] | null;
  collections?: (string | null)[] | null;
}

export interface TranslationInput {
  seoTitle?: string | null;
  seoKeyword?: string | null;
  seoDescription?: string | null;
  name?: string | null;
  description?: string | null;
  descriptionJson?: any | null;
}

export interface UserCreateInput {
  defaultBillingAddress?: AddressInput | null;
  defaultShippingAddress?: AddressInput | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  isActive?: boolean | null;
  isSubscribed?: boolean | null;
  note?: string | null;
  gender?: string | null;
  birthday?: any | null;
  countryArea?: string | null;
  phone?: string | null;
  redirectUrl?: string | null;
}

export interface UserInput {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  isActive?: boolean | null;
  isSubscribed?: boolean | null;
  note?: string | null;
}

export interface UserOperatePageEventFilterInput {
  search?: string | null;
  operateType?: (PageUserEventsEnum | null)[] | null;
  languageCode?: (LanguageCodeFilter | null)[] | null;
}

export interface UserSortingInput {
  direction: OrderDirection;
  field: UserSortField;
}

export interface VariantInput {
  variants?: (string | null)[] | null;
}

export interface VoucherFilterInput {
  status?: (DiscountStatusEnum | null)[] | null;
  timesUsed?: IntRangeInput | null;
  discountType?: (VoucherDiscountType | null)[] | null;
  started?: DateTimeRangeInput | null;
  search?: string | null;
  languageCode?: (LanguageCodeFilter | null)[] | null;
}

export interface VoucherInput {
  type?: VoucherTypeEnum | null;
  name?: string | null;
  code?: string | null;
  startDate?: any | null;
  endDate?: any | null;
  discountValueType?: DiscountValueTypeEnum | null;
  discountValue?: any | null;
  products?: (string | null)[] | null;
  collections?: (string | null)[] | null;
  categories?: (string | null)[] | null;
  languages?: (string | null)[] | null;
  minAmountSpent?: any | null;
  minCheckoutItemsQuantity?: number | null;
  countries?: (string | null)[] | null;
  applyNumberPerCustomer?: number | null;
  usageLimit?: number | null;
  applySpecificCustomer?: boolean | null;
  applyShopAll?: boolean | null;
  includeDiscountProduct?: boolean | null;
  includeComboProduct?: boolean | null;
  isAff?: boolean | null;
  isRepeatable?: boolean | null;
  descriptionText?: string | null;
  descriptionSubtext?: string | null;
  descriptionThirdtext?: string | null;
  displayOrder?: number | null;
  limitTime?: number | null;
}

export interface VoucherSortingInput {
  direction: OrderDirection;
  field: VoucherSortField;
}

export interface VoucherTranslationInput {
  name?: string | null;
  descriptionText?: string | null;
  descriptionSubtext?: string | null;
  descriptionThirdtext?: string | null;
}

export interface WarehouseAddressInput {
  streetAddress1: string;
  streetAddress2?: string | null;
  city: string;
  cityArea?: string | null;
  postalCode?: string | null;
  country: CountryCode;
  countryArea?: string | null;
  phone?: string | null;
}

export interface WarehouseCreateInput {
  slug?: string | null;
  companyName?: string | null;
  email?: string | null;
  name: string;
  address: WarehouseAddressInput;
  shippingZones?: (string | null)[] | null;
}

export interface WarehouseFilterInput {
  search?: string | null;
  ids?: (string | null)[] | null;
}

export interface WarehouseSortingInput {
  direction: OrderDirection;
  field: WarehouseSortField;
}

export interface WarehouseUpdateInput {
  slug?: string | null;
  companyName?: string | null;
  email?: string | null;
  name?: string | null;
  address?: WarehouseAddressInput | null;
}

export interface WebhookCreateInput {
  name?: string | null;
  targetUrl?: string | null;
  events?: (WebhookEventTypeEnum | null)[] | null;
  serviceAccount?: string | null;
  app?: string | null;
  isActive?: boolean | null;
  secretKey?: string | null;
}

export interface WebhookFilterInput {
  search?: string | null;
  isActive?: boolean | null;
}

export interface WebhookSortingInput {
  direction: OrderDirection;
  field: WebhookSortField;
}

export interface WebhookUpdateInput {
  name?: string | null;
  targetUrl?: string | null;
  events?: (WebhookEventTypeEnum | null)[] | null;
  serviceAccount?: string | null;
  app?: string | null;
  isActive?: boolean | null;
  secretKey?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
